<template>
    <svg viewBox="0 0 16 16" fill="none" stroke="currentColor" stroke-width="2">
        <path d="M3.5 8.5L6.5 11.5L12.5 4.5" />
    </svg>
</template>

<script lang="ts" setup vapor>
defineOptions({ name: 'CheckIcon' });
</script>
